import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {uuid} from 'vue-uuid';

const camelcaseObjectDeep = require('camelcase-object-deep');

Vue.use(VueAxios, axios);

let promiseCollection = [];

let findPromiseIndex = (url) => {
    return promiseCollection.findIndex(promiseUrl => promiseUrl === url)
}

const shouldSkipGlobal500Redirect = (requestUrl) => {
    if (!requestUrl) return false;
    return requestUrl.includes('v1/order/confirm')
        || requestUrl.includes('v1/order/fast-order/confirm')
        || requestUrl.includes('v1/calculators/');
};

const shouldSkipGlobal404Redirect = (requestUrl) => {
    if (!requestUrl) return false;

    const ignored404Paths = [
        'v1/deliveries',
        '/similar',
        'v1/translations',
        'v1/basket',
        'v1/order/payment-status',
        'v1/order/payment-sync',
        'v1/page/',
    ];

    return ignored404Paths.some((path) => requestUrl.includes(path));
};

export const isAbortedRequest = (error) => {
    if (!error) {
        return false;
    }

    if (axios.isCancel(error)) {
        return true;
    }

    return error.code === 'ECONNABORTED' || error.message === 'Request aborted';
};

if (!localStorage.getItem('guid')) {
    localStorage.setItem('guid', uuid.v1())
}


export const $http = axios.create({

    baseURL: process.env.VUE_APP_ROOT_API || '/api/',
    headers: {
        'Basket-id': `${localStorage.getItem('guid')}`,
        'Authorization': `Bearer ${localStorage.getItem('user_token')}`,
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
});
$http.interceptors.request.use((config) => {
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('user_token')}`;
    config.headers['X-localization'] = store.getters.currentLanguage?.translationKey || 'uk';
    config.headers['Access-Control-Allow-Origin'] = "X-Requested-With";
    config.headers['Access-Control-Allow-Headers'] = "*";
    config.headers['Access-Control-Allow-Methods'] = "Get, Post, Options";


    let globalRequestsFlag = store.getters['system/globalRequestsFlag'];
    if (globalRequestsFlag) {
        promiseCollection.push(config.url)
    }

    return config;
});
$http.interceptors.response.use((response) => {
        response.data = camelcaseObjectDeep(response.data);

        let index = findPromiseIndex(response.config.url)
        if (index > -1) {
            promiseCollection.splice(index, 1);
        }

        if (!promiseCollection.length) {
            store.commit(`system/SET_REQUESTS_FLAG`, false)
        }

        return response;
    }, (error) => {
        const response = error && error.response ? error.response : null;
        const status = response ? response.status : null;
        const requestUrl = (response && response.config ? response.config.url : null)
            || (error.config ? error.config.url : null);

        let index = findPromiseIndex(requestUrl)
        if (index > -1) {
            promiseCollection.splice(index, 1);
        }
        if (!promiseCollection.length) {
            store.commit(`system/SET_REQUESTS_FLAG`, false)
        }

        switch (status) {
            case 500: {
                console.error('[http][500]', {
                    requestUrl,
                    routeName: router.currentRoute && router.currentRoute.name ? router.currentRoute.name : null,
                    skipGlobalRedirect: shouldSkipGlobal500Redirect(requestUrl)
                });
                if (!shouldSkipGlobal500Redirect(requestUrl) && router.currentRoute.name !== 'server-not-found') {
                    router.push({name: 'server-not-found'}).catch(() => {
                        console.log()
                    });
                }
                break;
            }
            case 404: {
                if (
                    router.currentRoute.name !== 'page-not-found'
                    && !shouldSkipGlobal404Redirect(requestUrl)
                ) {
                    router.replace({name: 'page-not-found'}).catch(() => {
                        console.log()
                    });
                }
                break;
            }
            case 401: {
                store.commit('auth/RESET_TOKEN');
                // Тимчасово: не примушуємо авторизуватись через popup на 401.
                break;
            }
            default: {
                break;
            }
        }

        if (!response) {
            return Promise.reject(error);
        }

        return Promise.reject(camelcaseObjectDeep(response));
    }
);

export default function install(Vue) {
    Object.defineProperty(Vue.prototype, '$http', {
        get() {
            return $http
        }
    })
}

// export function getRedirectUri(uri) {
//   try {
//     return !isUndefined(uri)
//       ? `${$window.location.origin}${uri}`
//       : $window.location.origin;
//   } catch (e) {
//   }
//
//   return uri || null;
// }
